// Wordt als eerste module geladen, nog voor main.ts en alles wat die
// importeert. Het enige doel: zorgen dat een fout zichtbaar wordt.
//
// Binnen de Discord-iframe is een wit scherm het meest nutteloze
// foutbericht dat er bestaat. Gooit een module tijdens het laden een fout,
// dan draait main.ts nooit en is er dus ook geen logboek om in te kijken.
// Deze banner staat er los van en overleeft dat.

function banner(): HTMLElement {
  const existing = document.querySelector<HTMLElement>('#boot-error')
  if (existing) return existing

  const node = document.createElement('div')
  node.id = 'boot-error'
  node.setAttribute(
    'style',
    [
      'position:fixed',
      'inset:0 0 auto 0',
      'z-index:9999',
      'background:#3b1f22',
      'border-bottom:2px solid #e06c75',
      'color:#f3d7da',
      'font:13px/1.5 ui-monospace,Menlo,Consolas,monospace',
      'padding:12px 14px',
      'max-height:60vh',
      'overflow:auto',
      'white-space:pre-wrap',
      'word-break:break-word',
    ].join(';'),
  )
  document.body.prepend(node)
  return node
}

function show(title: string, detail: string): void {
  const node = banner()
  const line = document.createElement('div')
  // textContent, want de tekst kan van buiten komen.
  line.textContent = `${title}: ${detail}`
  node.append(line)
}

window.addEventListener('error', (event) => {
  const where = event.filename ? ` (${event.filename}:${event.lineno})` : ''
  show('Fout bij laden', `${event.message}${where}`)
})

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason
  const text = reason instanceof Error ? reason.message : String(reason)
  show('Onafgehandelde fout', text)
})
